import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, today, OPC, fmtEur } from "@/lib/api";
import { PatientPicker } from "@/components/ApptDialog";

const TL = { bono: "Bono", syntonic: "Syntonic", tomatis: "Tomatis", wivi: "Wivi", sesiones: "Sesiones" };
const L = ({ t, children }) => <label className="block text-[11px] font-semibold uppercase tracking-wider text-slate-500">{t}<div className="mt-1">{children}</div></label>;

export const CobroDialog = ({ open, onClose, onDone, patient }) => {
  const [p, setP] = useState(null);
  const [trs, setTrs] = useState([]);
  const [f, setF] = useState({ fecha: today(), importe: "", metodo: "Tarjeta", concepto: "", treatment_id: "" });
  useEffect(() => {
    if (open) { setP(null); setTrs([]); setF({ fecha: today(), importe: "", metodo: "Tarjeta", concepto: "", treatment_id: "" }); if (patient) pick(patient); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  const pick = async (x) => {
    setP(x);
    if (!x) return setTrs([]);
    const { data } = await api.get(`/patients/${x.id}`);
    const t = (data.treatments || []).filter((t) => t.estado !== "anulado");
    setTrs(t);
    const debe = t.find((t) => t.pendiente_pago > 0);
    setF((o) => ({ ...o, treatment_id: debe?.id || "", importe: debe ? String(Math.round(debe.pendiente_pago * 100) / 100) : o.importe }));
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    try {
      await api.post("/eco/cobros", { ...f, patient_id: p?.id, importe: Number(f.importe), treatment_id: f.treatment_id || null });
      toast.success("Cobro apuntado");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="cobro-dialog">
        <DialogHeader><DialogTitle className="font-[Outfit]">Apuntar cobro</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2"><L t="Paciente"><PatientPicker value={p?.id} label={p?.nombre} onPick={pick} /></L></div>
          {p && <div className="col-span-2"><L t="Corresponde a">
            <select className="field-select" value={f.treatment_id} onChange={set("treatment_id")} data-testid="cobro-tratamiento">
              <option value="">Otro concepto (gafas, examen, consulta...)</option>
              {trs.map((t) => <option key={t.id} value={t.id}>{TL[t.tipo] || t.tipo}{t.modalidad ? ` · ${t.modalidad}` : ""} · debe {fmtEur(t.pendiente_pago)}</option>)}
            </select></L></div>}
          <div className="col-span-2"><L t="Concepto"><Input value={f.concepto} onChange={set("concepto")} data-testid="cobro-concepto" placeholder={f.treatment_id ? "Opcional, p. ej. 2.º plazo" : "Ej.: Gafas graduadas"} /></L></div>
          <L t="Importe €"><Input type="number" step="0.01" value={f.importe} onChange={set("importe")} data-testid="cobro-importe" /></L>
          <L t="Fecha"><Input type="date" value={f.fecha} onChange={set("fecha")} data-testid="cobro-fecha" /></L>
          <L t="Forma de pago"><select className="field-select" value={f.metodo} onChange={set("metodo")} data-testid="cobro-metodo">{OPC.metodo_pago.map((m) => <option key={m}>{m}</option>)}</select></L>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={save} disabled={!p || !(Number(f.importe) > 0)} data-testid="cobro-save" className="bg-[#1E3A8A] hover:bg-[#1E40AF]">Guardar cobro</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
